export enum WalkingAid {
  NO_HELP = 0,
  UNILATERAL_HELP = 1,
  BILATERAL_HELP = 2,
  ACCOMPANYING_PERSON = 3,
}

export const walkingAidMapping = {
  [WalkingAid.NO_HELP]: $localize`:@@common_walkingAid_noHelp:No help`,
  [WalkingAid.UNILATERAL_HELP]: $localize`:@@common_walkingAid_unilateralHelp:Unilateral help`,
  [WalkingAid.BILATERAL_HELP]: $localize`:@@common_walkingAid_bilateralHelp:Bilateral help`,
  [WalkingAid.ACCOMPANYING_PERSON]: $localize`:@@common_walkingAid_accompanyingPerson:Accompanying person`,
};
